import script from "./CxDhLegendConfigurator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxDhLegendConfigurator.vue?vue&type=script&setup=true&lang=ts"

import "./CxDhLegendConfigurator.vue?vue&type=style&index=0&id=f6f8253a&lang=less"

const __exports__ = script;

export default __exports__